/**
 * @desc 批量下载报关单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.DeclarationDownloadResponseDto>;
export function request(
  body: defs.tms.CustomsDeclarationMasterRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/downloadDeclarationList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
